import { Button, Container, Typography } from "@mui/material";
import { useNavigate } from 'react-router-dom';

export const SinPermisoProyectoPage:React.FC<{}> = () => {
    let history = useNavigate();

    return(
        <Container maxWidth="sm" sx={{mt:8}}>
          <div style={{ textAlign: 'center', marginTop: '2rem' }}>
            <Typography variant="h4" component="h1">
                No Autorizado
            </Typography>
            <Typography variant="body1">
              No tienes permisos sobre el proyecto al que intentas ingresar.
            </Typography>
            <br />
            <Button variant="contained" aria-label="delete" color="primary" onClick={() => {history('/')}}>
            VOLVER
            </Button>         
          </div>
        </Container>
    );
}